import { render, staticRenderFns } from "./BlikCode.vue?vue&type=template&id=5897ef54&scoped=true&"
import script from "./BlikCode.vue?vue&type=script&lang=ts&"
export * from "./BlikCode.vue?vue&type=script&lang=ts&"
import style0 from "./BlikCode.vue?vue&type=style&index=0&id=5897ef54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5897ef54",
  null
  
)

export default component.exports